import * as React from 'react';
import styled from '@emotion/styled';
import { loadMoreUGCReviews, setReviewSorting } from '../../../actions/ugcAction';
import { Specials } from '../../../components/Specials/Specials';
import { __ } from '../../../helpers/TranslationService';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { CabinTable } from './CabinTable';
import { UserGeneratedContentSection } from './UserGeneratedContentSection';
import { config } from '../../../config';
import { RequestFormBtn } from './RequestFormBtn';
import { REQUEST_FORM_VALIDATORS } from '../../../reducers/requestForm/requestFormMappers';
import { PASSENGER_SELECTION_ID } from './PassengerSelectSection';

export interface ICruisePriceSection {
    startHarbour?: string;
    endHarbour?: string;
    cheapestCabinId: number;
    onCabinSelection?: (event: any) => void;
    selectedCabinId?: number;
    cabinSectionRef?: React.MutableRefObject<HTMLDivElement> | null;
    isNextButtonDisabled?: boolean;
    selectedCabinUrl: string;
}

const StyledContainer = styled.div`
    position: relative;
    padding-top: 0;
    background: ${(props) => props.theme.colors.desertStorm[100]};
`;

const StyledLoaderContainer = styled.div`
    position: absolute;
    z-index: ${(props) => props.theme.overlayIndexes.mobileCruisePriceLoader};
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.5);

    img {
        top: 50%;
        width: 100px;
        position: relative;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

const CruisePriceSection = (props: ICruisePriceSection) => {
    const [isSubmitted, setIsSubmitted] = React.useState(false);

    const {
        pageData,
        cruisePage,
        ui,
        reviews: reviewsData,
        requestForm,
        router,
    } = useTypedSelector((state) => state);

    const { isLoadingGlobal } = ui;
    const { sails, loadingRates } = cruisePage;

    if (isLoadingGlobal) return null;

    const numberOfReviews = reviewsData?.reviews?.aggregation?.data?.attributes?.numRatings;
    const isDesktop = pageData.deviceType === 'desktop';
    const showCabinTable = !isDesktop && sails.length > 0;

    const getStepValidity = () => {
        setIsSubmitted(true);
        const childAges = requestForm.childAges;
        const isValidChildAges = REQUEST_FORM_VALIDATORS.isAgeArrayValid(childAges);

        if (!isValidChildAges) {
            const el = document.getElementById(PASSENGER_SELECTION_ID);
            el.scrollIntoView();
        }

        return isValidChildAges;
    };

    return (
        <div>
            <div className="lineSeparator" />

            {!isDesktop && cruisePage.specials?.length > 0 && (
                <Specials specials={cruisePage.specials as any} />
            )}

            {!isDesktop && Boolean(numberOfReviews) && (
                <UserGeneratedContentSection
                    cruisePage={cruisePage}
                    reviewsData={reviewsData}
                    pageData={pageData}
                    loadMoreUGCReviews={loadMoreUGCReviews}
                    setReviewSorting={setReviewSorting}
                />
            )}

            <StyledContainer className="cruisePageSection">
                {loadingRates && (
                    <StyledLoaderContainer>
                        <img alt="price loading" src={`${config.images}/common/loading.gif`} />
                    </StyledLoaderContainer>
                )}
                {showCabinTable && (
                    <CabinTable
                        cabinSectionRef={props.cabinSectionRef}
                        cheapestCabinId={props.cheapestCabinId}
                        onCabinSelection={(e) => props.onCabinSelection(e)}
                        selectedCabinId={props.selectedCabinId}
                        isSubmitted={isSubmitted}
                    />
                )}

                <div className="cruisePageRequestFormBtn hideDesktopAndUp">
                    <RequestFormBtn
                        getStepValidity={getStepValidity}
                        url={props.selectedCabinUrl}
                        disabled={props.isNextButtonDisabled}
                        router={router}
                    />
                </div>
            </StyledContainer>
        </div>
    );
};
export default CruisePriceSection;
